module.exports = __webpack_public_path__ + "img/pr-11.7f4f6c9c.png";